import { BaseError } from "./BaseError";
/**
 * Argument error
 */ export class ArgumentError extends BaseError {
    constructor(argumentName, errorMessage){
        super(), this.argumentName = argumentName, this.errorMessage = errorMessage;
        if (argumentName) {
            this.message = `${argumentName} was invalid. ${errorMessage || ""}`.trim();
        } else {
            this.message = errorMessage || "";
        }
        this.name = "ArgumentError";
    }
}
